import React from 'react';
import { Heading, HeadingHierarchy } from '../../Heading/Heading';
import { PostsEditorWithUploadAndAttachedFiles } from '../editors/PostsEditorWithUploadAndAttachedFiles';
import { PostsEditor } from '../editors/PostsEditor';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { PostFirst, PostReply, PostTypes, isPostFirst } from '../Post.types';
import { HiddenParam, RichTextParam, SonForm } from '../../../Form2';

export type PostUpdateForm = SonForm<RichTextParam<'content'> | HiddenParam<'postId'>>;

type PostUpdateFormProps = {
  type: PostTypes;
  form: PostUpdateForm;
  post: PostFirst | PostReply;
  headingHierarchy: HeadingHierarchy;
};

export function PostUpdateForm({ type, form, post, headingHierarchy }: PostUpdateFormProps) {
  const { t } = useSonTranslation('Posts');

  return (
    <>
      <Heading className="posts__heading font-bold-15-19" hierarchy={headingHierarchy}>
        {t(`default.heading.edit.${type}`)}
      </Heading>
      {type === 'thread' ? (
        <PostsEditorWithUploadAndAttachedFiles
          form={form}
          type={type}
          attachments={post && isPostFirst(post) ? post.attachments : undefined}
          attachedFileUpdateOrder={post && isPostFirst(post) ? post.attachedFileUpdateOrder : undefined}
          postId={post?.id}
        />
      ) : (
        <PostsEditor form={form} type={type} autoFocus uuid={post?.id} />
      )}
    </>
  );
}
